import {
  isEmpty as _isEmpty,
  forEach as _forEach,
  find as _find,
  omitBy as _omitBy,
  cloneDeep as _cloneDeep,
  filter as _filter
} from 'lodash-es';
import moment from 'moment';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';

const initialQuery = {
  filters: [],
  measures: [],
  dimensions: [],
  timezone: 'Asia/Kolkata',
  timeDimensions: [
    {
      dateRange: ['2022-05-09', '2022-05-16'],
      dimension: '',
      compareRange: []
    }
  ],
  aggregationTypes: {},
  negativeMeasures: {},
  order: {}
};
const supportedPageType = ['dashboard'];
const dimensionAndMetricForTopCardColorChangeList = [
  {
    metric: 'MgOrders',
    dimension: 'customGroupedOrderStatus',
    dimensionValues: ['GRAAS_CANCELLED_STATUS_GRAAS', 'GRAAS_RETURNED_STATUS_GRAAS']
  },
  {
    metric: 'Revenue',
    dimension: 'customGroupedOrderStatus',
    dimensionValues: ['GRAAS_CANCELLED_STATUS_GRAAS', 'GRAAS_RETURNED_STATUS_GRAAS']
  }
];

// --- Build QueryConfig
export const getQueryConfig = (mappings, metricList, groupBy) => {
  if ((!_isEmpty(mappings) && !_isEmpty(mappings.data)) || !_isEmpty(metricList)) {
    let config_for_query = [];
    _forEach(metricList, metricName => {
      const matchedList = _find(mappings?.data, data => data?.metric_set?.code === metricName) || [];
      config_for_query = [
        ...config_for_query,
        {
          code: metricName,
          query_configs: matchedList
        }
      ];
    });

    const queryObject = {
      metric_list: config_for_query,
      dimension_list: groupBy
    };
    const uniqueConfigObject = _omitBy(queryObject, _isEmpty);

    return uniqueConfigObject;
  }

  return null;
};

// --- Build Query
export const generateQuery = (metrics, queryConfig, chart_type) => {
  let query = [];
  let queryClone = _cloneDeep(initialQuery);

  // --- build query for PIE chart
  if (chart_type === 'pie') {
    if (!_isEmpty(metrics)) {
      const findRelatedObj = queryConfig?.metric_list.find(obj => obj.code === metrics) || {};
      queryClone['measures'] = [metrics];
      queryClone['dimensions'] = [queryConfig?.dimension_list];
      queryClone['timeDimensions'][0]['dimension'] = findRelatedObj?.query_configs?.metric_set?.query_date_column;
      queryClone['aggregationTypes'] = { [metrics]: findRelatedObj?.query_configs?.metric_set?.is_negative || false };
      queryClone['negativeMeasures'] = { [metrics]: findRelatedObj?.query_configs?.metric_set?.aggregation_type };
      queryClone['order'] = { [metrics]: 'desc' };
      query = [queryClone];
      console.log({ query });
    }
  }

  // --- build query for TABLE chart
  if (chart_type === 'table') {
    let negativeMeasures = {};
    let aggregationTypes = {};

    queryClone['limit'] = 50;
    queryClone['measures'] = queryConfig?.metric_list?.map(metric => metric.code);
    queryClone['timeDimensions'][0]['dimension'] =
      queryConfig?.metric_list?.[0]?.query_configs?.metric_set?.query_date_column;

    _forEach(queryConfig?.metric_list, config => {
      negativeMeasures[config?.query_configs?.metric_set?.code] =
        config?.query_configs?.metric_set?.is_negative || false;
      aggregationTypes[config?.query_configs?.metric_set?.code] = config?.query_configs?.metric_set?.aggregation_type;
    });

    queryClone['aggregationTypes'] = aggregationTypes;
    queryClone['negativeMeasures'] = negativeMeasures;
    queryClone['order'] = { [queryConfig?.metric_list?.[0]?.query_configs?.metric_set?.code]: 'desc' };
    query = [queryClone];

    console.log({ queryClone });
  }

  // --- build query for LINE chart
  if (chart_type === 'line') {
    if (!_isEmpty(queryConfig?.metric_list)) {
      _forEach(queryConfig?.metric_list, metric => {
        const initialQueryClone = _cloneDeep(initialQuery);
        initialQueryClone['measures'] = metric?.code;
        initialQueryClone['timeDimensions'][0]['dimension'] = metric?.query_configs?.metric_set?.query_date_column;
        initialQueryClone['aggregationTypes'] = {
          [metric?.code]: metric?.query_configs?.metric_set?.aggregation_type
        };
        initialQueryClone['negativeMeasures'] = {
          [metric?.code]: metric?.query_configs?.metric_set?.is_negative ? true : false
        };
        query = [...query, initialQueryClone];
      });
    }
  }

  return query;
};

export const stringToMoment = rangeStrings =>
  rangeStrings ? [moment(rangeStrings[0]).format('YYYY-MM-DD'), moment(rangeStrings[1]).format('YYYY-MM-DD')] : null;

export const convertQueryBystatus = (queryArray, storeFilter) => {
  const convertedQueryArray =
    !_isEmpty(queryArray) &&
    queryArray?.map(singlequeryObject => {
      const filterArray = singlequeryObject?.filters;
      return {
        ...singlequeryObject,
        filters: filterArray?.map(singleFilterObject => {
          return singleFilterObject?.dimension === 'MgOrders.status'
            ? {
                ...singleFilterObject,
                values: storeFilter
              }
            : singleFilterObject;
        })
      };
    });

  return convertedQueryArray || [];
};

export const generateFingerPrint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  }

export const mouseflowTrack = async (data, customTag) => {
  if (process.env.REACT_APP_MOUSEFLOW_KEY) {
    if (process.env.NODE_ENV === 'production') {
      const fingerPrint = generateFingerPrint();
      window._mfq?.push(['setVariable', 'fingerPrintID', fingerPrint]);
      window._mfq?.push(['tag', data?.storeCode]);
      window._mfq?.push(['setVariable', 'userName', data?.username]);
      window._mfq?.push(['setVariable', 'email', data?.email]);
      window._mfq?.push(['setVariable', 'sellerID', data?.storeCode]);
      if (data?.isDemoAccount) {
        window._mfq?.push(['tag', 'isDemoAccount']);
      }
      if (data?.username.indexOf('admin') > 0) {
        window._mfq?.push(['tag', 'admin']);
      } else {
        window._mfq?.push(['tag', 'seller']);
      }
      if (customTag) {
        window._mfq?.push(['tag', customTag]);
      } else {
        console.log(data);
      }
    }
  }
};

export const checkToApplyColor = (isTopCard, pageType, queryFilter) => {
  if (queryFilter != undefined && isTopCard && supportedPageType.includes(pageType) && isMetricsContains(queryFilter)) {
    return true;
  }
  return false;
};

const isMetricsContains = queryFilter => {
  for (let i = 0; i < dimensionAndMetricForTopCardColorChangeList.length; i++) {
    let dimensionAndMetricForTopCardColorChange = dimensionAndMetricForTopCardColorChangeList[i];
    let filteredQuery = _filter(queryFilter, function (filter) {
      return (
        filter?.dimension?.split('.')?.[0] === dimensionAndMetricForTopCardColorChange?.metric &&
        filter?.dimension?.split('.')?.length > 1 &&
        filter?.dimension?.split('.')?.[1] === dimensionAndMetricForTopCardColorChange?.dimension &&
        listContainsCheck(filter?.values || [], dimensionAndMetricForTopCardColorChange?.dimensionValues || [])
      );
    });
    if (filteredQuery.length > 0) {
      return true;
    }
  }
  return false;
};

const listContainsCheck = (listOfQueryMetrics, listOfMetrics) => {
  for (let i = 0; i < listOfMetrics.length; i++) {
    if (listOfQueryMetrics.includes(listOfMetrics[i])) {
      return true;
    }
  }
  return false;
};
